const PRODUCT_SEARCH_DISPLAY_PARAM = 'display_q';

function productSearchTokens(term) {
  return (term.slice(0, 200).match(/[\p{L}\p{N}]+/gu) || []).slice(0, 12);
}

function mainScopedProductQuery(term) {
  const tokens = productSearchTokens(term);
  if (!tokens.length) return '';
  const title = tokens.map((token) => `title:${token}`).join(' ');
  const tags = tokens.map((token) => `tag:${token}`).join(' ');
  return `(${title}) OR (${tags})`;
}

function mainDisplayProductQuery(url) {
  const display = url.searchParams.get(PRODUCT_SEARCH_DISPLAY_PARAM);
  if (display !== null) return display.trim().slice(0, 200);

  const query = url.searchParams.get('q')?.trim() || '';
  const titleGroup = query.match(/^\(([^)]+)\) OR \([^)]+\)$/)?.[1] || '';
  const tokens = Array.from(titleGroup.matchAll(/title:([^\s)]+)/g), (match) => match[1]);
  return tokens.length ? tokens.join(' ').slice(0, 200) : query.slice(0, 200);
}

class MainSearch extends SearchForm {
  constructor() {
    super();
    if (this.constrainSearchRequest()) return;
    this.displayTerm = mainDisplayProductQuery(new URL(window.location.href));
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
    this.presentDisplayTerm();
    window.syncProductSearchDisplay = this.presentDisplayTerm.bind(this);
  }

  constrainSearchRequest() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has('q')) return false;

    const displayTerm = mainDisplayProductQuery(url);
    const scopedQuery = mainScopedProductQuery(displayTerm);
    if (!scopedQuery) return false;

    const constrained =
      url.searchParams.get('q') === scopedQuery &&
      url.searchParams.get('type') === 'product' &&
      url.searchParams.get('options[prefix]') === 'last' &&
      url.searchParams.get(PRODUCT_SEARCH_DISPLAY_PARAM) === displayTerm;
    if (constrained) return false;

    url.searchParams.set('q', scopedQuery);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    url.searchParams.set(PRODUCT_SEARCH_DISPLAY_PARAM, displayTerm);
    url.searchParams.delete('options[fields]');
    window.location.replace(url.href);
    return true;
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.form.addEventListener('submit', this.onConstrainedSubmit.bind(this));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onConstrainedSubmit(event) {
    if (event.defaultPrevented) return;
    const displayTerm = this.input.value.trim().slice(0, 200);
    const scopedQuery = mainScopedProductQuery(displayTerm);
    if (!scopedQuery) {
      event.preventDefault();
      return;
    }

    this.input.value = scopedQuery;
    let displayInput = this.input.form.querySelector(`input[name="${PRODUCT_SEARCH_DISPLAY_PARAM}"]`);
    if (!displayInput) {
      displayInput = document.createElement('input');
      displayInput.type = 'hidden';
      displayInput.name = PRODUCT_SEARCH_DISPLAY_PARAM;
      this.input.form.appendChild(displayInput);
    }
    displayInput.value = displayTerm;
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }

  presentDisplayTerm() {
    const url = new URL(window.location.href);
    const scopedQuery = url.searchParams.get('q') || '';
    this.displayTerm = mainDisplayProductQuery(url);
    if (!this.displayTerm) return;

    this.allSearchInputs.forEach((input) => {
      input.value = this.displayTerm;
    });

    const root = document.querySelector('.template-search');
    if (root && scopedQuery && scopedQuery !== this.displayTerm) {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        if (node.parentElement?.closest('script, style, template')) return;
        node.nodeValue = node.nodeValue.replaceAll(scopedQuery, this.displayTerm);
      });
      document.title = document.title.replaceAll(scopedQuery, this.displayTerm);
    }

    document.querySelectorAll('facet-filters-form form').forEach((form) => {
      let displayInput = form.querySelector(`input[name="${PRODUCT_SEARCH_DISPLAY_PARAM}"]`);
      if (!displayInput) {
        displayInput = document.createElement('input');
        displayInput.type = 'hidden';
        displayInput.name = PRODUCT_SEARCH_DISPLAY_PARAM;
        form.appendChild(displayInput);
      }
      displayInput.value = this.displayTerm;
    });

    const searchPath = new URL(this.input.form.action, window.location.origin).pathname;
    document.querySelectorAll('.template-search a[href]').forEach((anchor) => {
      const href = new URL(anchor.href, window.location.origin);
      if (href.origin !== window.location.origin || href.pathname !== searchPath || !href.searchParams.has('q')) return;
      href.searchParams.set(PRODUCT_SEARCH_DISPLAY_PARAM, this.displayTerm);
      href.searchParams.set('type', 'product');
      href.searchParams.set('options[prefix]', 'last');
      href.searchParams.delete('options[fields]');
      anchor.setAttribute('href', `${href.pathname}${href.search}${href.hash}`);
    });
  }
}

customElements.define('main-search', MainSearch);
